import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import Separator from "@components/CustomTypography/Separator/Separator"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./YoutubePrivacyPolicyContent.module.scss"
type Props = {
	data: AdvancedSideAssetModuleType
}

const YoutubePrivacyPolicyContent = (props: Props) => {
	return (
		<ContainerWrapper>
			<Separator className={styles.container} size={128}>
				<Description content={props.data?.mainContent?.[0].content} />
			</Separator>
		</ContainerWrapper>
	)
}

export default YoutubePrivacyPolicyContent
